import { teamSlides } from './TeamSlideshow';

// Pick a curated set of the strongest atmosphere shots
const stripSlides = [
  teamSlides.find((s) => s.caption === 'Bootstour in Valencia'),
  teamSlides.find((s) => s.caption === 'Horbach Bühne'),
  teamSlides.find((s) => s.caption === 'Yacht-Tag auf dem Mittelmeer'),
  teamSlides.find((s) => s.caption === 'Dinner über Barcelona'),
  teamSlides.find((s) => s.caption === 'Strategie in den Alpen'),
  teamSlides.find((s) => s.caption === 'Helikopter-Incentive'),
].filter(Boolean) as { url: string; alt: string; caption: string }[];

const TeamMomenteStrip = () => {
  return (
    <section aria-label="Team-Momente" className="bg-background border-b border-border/60">
      <div className="container mx-auto px-6 py-6 md:py-8">
        <div className="flex items-center justify-between mb-4">
          <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold">
            Team & Momente
          </p>
          <a
            href="#mehr-als-ein-job"
            className="text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            Mehr sehen
          </a>
        </div>

        {/* Mobile: horizontal snap-scroll */}
        <div className="md:hidden -mx-6 px-6 flex gap-3 overflow-x-auto snap-x snap-mandatory pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {stripSlides.map((s) => (
            <div
              key={s.url}
              className="snap-start shrink-0 w-40 aspect-square rounded-2xl overflow-hidden bg-muted"
            >
              <img
                src={s.url}
                alt={s.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

        {/* Desktop: grid */}
        <div className="hidden md:grid grid-cols-6 gap-3">
          {stripSlides.map((s) => (
            <div
              key={s.url}
              className="aspect-square rounded-2xl overflow-hidden bg-muted group"
            >
              <img
                src={s.url}
                alt={s.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamMomenteStrip;
